var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"vcol vfcol vmid\">\n    <textarea class=\"vtextarea vedit\" data-hook=\"param\"></textarea>\n</div>\n";
},"useData":true});